import { render, staticRenderFns } from "./DubanAnalyze.vue?vue&type=template&id=87f51cd2&scoped=true"
import script from "./DubanAnalyze.vue?vue&type=script&lang=js"
export * from "./DubanAnalyze.vue?vue&type=script&lang=js"
import style0 from "./DubanAnalyze.vue?vue&type=style&index=0&id=87f51cd2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f51cd2",
  null
  
)

export default component.exports